export const actions = {
  async list({ rootState }, params) {
    if (!params.silent) rootState.loading = true

    try {
      const query = [`auditoria.uuid=${encodeURIComponent(params.auditoria)}`, 'order[createdAt]=desc', 'pagination=false']

      if (params.habilitado !== undefined) {
        query.push(`habilitado=${params.habilitado === true ? 1 : 0}`)
      }

      const res = await this.$axios.get(`auditoria_qr_offlines?${query.join('&')}`)

      return res.data['hydra:member']
    } finally {
      if (!params.silent) rootState.loading = false
    }
  },

  async get({ rootState }, payload) {
    if (!payload.silent) rootState.loading = true
    try {
      const res = await this.$axios.get(`auditoria_qr_offlines/${payload.uuid}`)

      return res.data
    } finally {
      if (!payload.silent) rootState.loading = false
    }
  },

  async create({ rootState }, payload) {
    rootState.loading = true
    const res = await this.$axios.post('auditoria_qr_offlines', payload)
    rootState.loading = false

    return res.data
  },

  async update({ rootState }, payload) {
    rootState.loading = true
    const res = await this.$axios.patch(`auditoria_qr_offlines/${payload.uuid}`, payload.body, {
      headers: {
        'Content-Type': 'application/merge-patch+json',
      },
    })
    rootState.loading = false

    return res.data
  },

  async receive({ rootState }, payload) {
    rootState.loading = true
    const headers = payload.body instanceof FormData ? {} : {
      'Content-Type': 'application/json',
    }
    const res = await this.$axios.post(`auditoria_qr_offlines/${payload.uuid}/recepcion`, payload.body, {
      headers,
    })
    rootState.loading = false

    return res.data
  },

  async consolidate({ rootState }, payload) {
    if (!payload.silent) rootState.loading = true
    try {
      const res = await this.$axios.post(`auditoria_qr_offlines/${payload.uuid}/consolidar`, {}, {
        headers: {
          'Content-Type': 'application/json',
        },
      })

      return res.data
    } finally {
      if (!payload.silent) rootState.loading = false
    }
  },
}
